var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4267 22.2561L16.189 17.7439C15.5996 18.252 14.8984 18.6484 14.0853 18.9329C13.2723 19.2175 12.4085 19.3598 11.4939 19.3598C9.25811 19.3598 7.36278 18.5874 5.8079 17.0427C4.25302 15.498 3.47559 13.6281 3.47559 11.4329C3.47559 9.23781 4.25302 7.36789 5.8079 5.82318C7.36278 4.27846 9.23778 3.5061 11.4329 3.5061C13.628 3.5061 15.4979 4.27846 17.0427 5.82318C18.5874 7.36789 19.3597 9.23781 19.3597 11.4329C19.3597 12.3069 19.2175 13.1504 18.9329 13.9634C18.6483 14.7764 18.2317 15.5386 17.6829 16.25L21.9511 21.0366L20.4267 22.2561ZM11.4634 17.2866C13.0691 17.2866 14.436 16.7124 15.564 15.564C16.692 14.4157 17.2561 13.0386 17.2561 11.4329C17.2561 9.82724 16.692 8.45021 15.564 7.30184C14.436 6.15346 13.0691 5.57927 11.4634 5.57927C9.81705 5.57927 8.42477 6.15346 7.28656 7.30184C6.14835 8.45021 5.57924 9.82724 5.57924 11.4329C5.57924 13.0386 6.14835 14.4157 7.28656 15.564C8.42477 16.7124 9.81705 17.2866 11.4634 17.2866ZM10.4878 14.7866V12.3171H8.04876V10.4878H10.5183V8.04879H12.3475V10.4878H14.7866V12.3171H12.3475V14.7866H10.4878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.a265aa0422e40c6e5ad776ca50f7496d.svg";
export { ForwardRef as ReactComponent };